module.exports = __webpack_public_path__ + "static/media/other-img-1.6f65186a.png";